import {ReactElement} from 'react';
import {Box, Button, Typography} from '@mui/material';
import {TFunction} from 'react-i18next';
import {Tray} from 'interfaces/Project';
import formatUnit from 'utils/formatUnit';

type Props = {
  tray: Tray;
  onSelect: () => void;
  onDetails: () => void;
  t: TFunction;
};

export default function TrayCard({tray, onSelect, onDetails, t}: Props): ReactElement {
  const specs = [
    {label: t('common:usefulSection'), value: formatUnit(tray.usefulSection, 'millimeter')},
    {
      label: t('common:maxLoad'),
      value:
        tray.maxLoad != null
          ? formatUnit(tray.maxLoad, 'kilogram-per-meter')
          : t('common:notAvailable')
    }
  ];

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        p: 1.5,
        border: '1px solid',
        borderColor: 'borderColor',
        borderRadius: '4px',
        backgroundColor: 'background.paper'
      }}
    >
      <Box>
        <Typography sx={{fontSize: 20, fontWeight: 500, lineHeight: 1.6, color: 'text.primary'}}>
          {tray.name}
        </Typography>
        <Typography sx={{fontSize: 14, fontWeight: 500, color: 'text.primary'}}>
          {t('common:referenceShort')}: {tray.clientReference}
        </Typography>
      </Box>
      <Box sx={{display: 'flex', gap: 1.5}}>
        {specs.map((spec) => (
          <Box key={spec.label} sx={{flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 0.5}}>
            <Typography sx={{fontSize: 16, color: 'text.primary'}}>{spec.label}</Typography>
            <Typography sx={{fontSize: 16, fontWeight: 700, color: 'text.primary'}}>
              {spec.value}
            </Typography>
          </Box>
        ))}
      </Box>
      <Box sx={{display: 'flex', gap: 1.5}}>
        <Button size="small" variant="outlined" color="primary" onClick={onSelect}>
          {t('common:select')}
        </Button>
        <Button size="small" color="inherit" sx={{color: 'ctaDark'}} onClick={onDetails}>
          {t('common:details')}
        </Button>
      </Box>
    </Box>
  );
}
